import { ExportFile } from '../types/export/export';
import {
  PdfTemplate,
  CreatePdfTemplateInput,
  UpdatePdfTemplateInput,
  DeletePdfTemplateInput,
} from '../types/pdf_template';
import { http } from '../util/https.util';

import { PaginatedResponse } from './common/paginatedResponse';

const LIST_URL = '/api/pdf/template/list';
const CREATE_URL = '/api/pdf/template/create';
const UPDATE_URL = '/api/pdf/template/update';
const DELETE_URL = '/api/pdf/template/delete';
const EXPORT_URL = '/api/pdf/export';
const SAMPLE_URL = '/api/pdf/sample';

export namespace PdfTemplateRequest {
  export const list = async (payload: { page: number }): Promise<PaginatedResponse<PdfTemplate>> => {
    return (await http.post(LIST_URL, payload)).data;
  };

  export interface CreatePayload {
    data: CreatePdfTemplateInput[];
  }
  export async function create(payload: CreatePayload): Promise<PdfTemplate[]> {
    const response = await http.post(CREATE_URL, payload);
    return response.data;
  }

  export interface UpdatePayload {
    data: UpdatePdfTemplateInput[];
  }
  export async function update(payload: UpdatePayload): Promise<PdfTemplate[]> {
    const response = await http.post(UPDATE_URL, payload);
    return response.data;
  }

  export interface DeletePayload {
    data: DeletePdfTemplateInput[];
  }
  export async function remove(payload: DeletePayload): Promise<PdfTemplate[]> {
    const response = await http.post(DELETE_URL, payload);
    return response.data;
  }

  export interface GeneratePayload {
    templateId: string;
    entityId: string;
  }
  export interface GenerateResponse extends ExportFile {}
  export async function generate(payload: GeneratePayload): Promise<any> {
    const response = await http.post(EXPORT_URL, payload);
    return response.data;
  }

  export interface SamplePayload {
    template: PdfTemplate;
    entityId: string;
  }
  export interface SampleRespone extends ExportFile {}
  export async function sample(payload: SamplePayload): Promise<any> {
    const response = await http.post(SAMPLE_URL, payload);
    return response.data;
  }
}
